/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from '../transformer';

export default class StudentJob extends Transformer {
  /**
   * @param studentJob
   *
   * @returns {Object} The transformed account
   */
  static fetch(studentJob) {
    return {
      id: studentJob.id,
      userId: studentJob.user_id,
      status: studentJob.status,
      mainPicture: studentJob.main_picture && studentJob.main_picture.format ? studentJob.main_picture.format.small : null,
      phone: studentJob.phone,
      leader: studentJob.leader,
      gender: studentJob.gender,
      firstName: studentJob.firstname,
      lastName: studentJob.lastname,
      birthdayDate: studentJob.birthday_date,
      feedbackScoreForCurrentCustomer: studentJob.feedback_score_for_current_customer,
      shortName: studentJob.short_name,
      softSkillsRatedByCustomer: studentJob.soft_skills_rated_by_customer,
    };
  }
}
